    <refactor-card-header>
    <div>
      <p class="main-card-description">
        Esta familia de agentes acelera los procesos de modernización de código en 3 ámbitos distintos:
      </p>
      <ul>
        <li class="main-card-list">Refactorización automática de código.
          <ul>
            <li class="main-card-list">La refactorización inteligente es el uso de algoritmos y técnicas de
              inteligencia artificial para automatizar y mejorar el proceso
              de refactorización del código. En lugar de depender únicamente del análisis manual, las herramientas
              basadas en IA puede Identificar
              patrones de código subóptimos, sugerir mejoras e incluso realizar modificaciones automáticamente, lo
              que permite a los desarrolladores
              centrarse en aspecto mas creativos y estratégicos del proyecto.
            </li>
          </ul>
        </li>
      </ul>
      <ul>
        <li class="main-card-list">Migración de versiones Java legacy a versiones de Java actuales.
          <ul>
            <li class="main-card-list">Modernización de código trasformando versiones antiguas realizadas sobre
              Java
              8 a versiones más actuales, teniendo en cuenta los
              innumerables cambios de contexto.
            </li>
          </ul>
        </li>
      </ul>
      <ul>
        <li class="main-card-list">Migración entre lenguajes de programación (entornos legacy a entornos a
          medida/cloud o de entornos propietarios a frameworks abiertos
          open source)
        </li>
      </ul>
      <div class="main-card-button-wrapper">
        <button class="main-card-button" (click)="goToUploadFiles()">Comenzar</button>
      </div>
    </div>
  </refactor-card-header>